import { ListDragAndDrop } from '../ListDragAndDrop/ListDragAndDrop';
import { CustomColumnsDragAndDropState } from '../../state/CustomColumnsDragAndDropState';

export const CustomColumnsDragAndDrop = {
  ...ListDragAndDrop,
  CustomColumnsDragAndDropState,
};
